<ui-loader *ngIf="loading"></ui-loader>

Refresh this page to see the loader again. It shows for 2 seconds and then fades out.

<br />
<br />
Inline loader <ui-loader [inline]="true"></ui-loader>
